import React from "react";
import * as AlertModule from "@mui/material/Alert/index.js";
import * as ButtonModule from "@mui/material/Button/index.js";
import * as CardModule from "@mui/material/Card/index.js";
import * as MobileStepperModule from "@mui/material/MobileStepper/index.js";
import * as PaperModule from "@mui/material/Paper/index.js";
import { resolveDefault } from "../../utils/moduleInterop";
import ResponsiveTypography from "../../components/ResponsiveTypography";

const Alert = resolveDefault<any>(AlertModule);
const Button = resolveDefault<any>(ButtonModule);
const Card = resolveDefault<any>(CardModule);
const MobileStepper = resolveDefault<any>(MobileStepperModule);
const Paper = resolveDefault<any>(PaperModule);

interface CustomMobileStepperProps {
	children: React.ReactNode;
	application_name: string;
	totalSteps: number;
	isStepperRequired: boolean;
	activeStep: number;
	handleNext: () => void;
	handleBack: () => void;
	validationErrorMsg?: string;
	nextButtonName: string;
	backButtonName: string;
}

const CustomMobileStepper: React.FC<CustomMobileStepperProps> = ({
	children,
	application_name,
	totalSteps,
	isStepperRequired,
	activeStep,
	handleNext,
	handleBack,
	validationErrorMsg,
	nextButtonName,
	backButtonName,
}) => {
	return (
		<>
			{application_name && (
				<Paper elevation={3} square={true}>
					<ResponsiveTypography>
						{application_name}
					</ResponsiveTypography>
				</Paper>
			)}
			{children}
			{validationErrorMsg && (
				<Alert severity="error" sx={{ mt: 1, mb: 0.5 }}>
					{validationErrorMsg}
				</Alert>
			)}
			<Card
				sx={{
					mb: 0.5,
					borderRadius: 1,
					width: "60%",
					marginLeft: "auto",
					marginRight: "auto",
					"@media (max-width: 960px)": {
						width: "100%",
					},
				}}
			>
				{" "}
				{isStepperRequired && (
					<MobileStepper
						variant="progress"
						steps={totalSteps}
						position="static"
						activeStep={activeStep}
						nextButton={
							<Button size="small" onClick={handleNext}>
								{nextButtonName}
							</Button>
						}
						backButton={
							<Button
								size="small"
								onClick={handleBack}
								disabled={activeStep === 0}
							>
								{backButtonName}
							</Button>
						}
					/>
				)}
			</Card>
		</>
	);
};

export default CustomMobileStepper;
